import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./Pages/Login";
import Layout from "./Layout";
import Dashboard from "./Pages/Dashboard";
import CustomerPage from "./Pages/Customers.js";
import AddUserPage from "./Pages/AddUsers.js";
import UserActivityPage from "./Pages/UserActivityList.js";
import NotificationsPage from "./Pages/Notifications.js";
import SendEmailPage from "./Pages/SendEmail.js";
import ProtectedRoute from "./Components/ProtectedRoutes.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import DataTable from "./Pages/DataTable.js";
import { analyticsRoutes } from "./config/analyticsRoutes.js";
import DailyDataTable from "./Pages/DailyDataTable.js";
import Analytics from "./Pages/Analytics.js";
import FailedLoginTable from "./Pages/FailedLoginTable.js";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          {/* 🔁 Redirect root (/) of protected area to /analytics/daily-data */}
          <Route index element={<Navigate to="/analytics/daily-data" replace />} />

          {/* Dashboard routes */}
          <Route path="/dashboard/companies" element={<Dashboard />} />
          <Route path="/dashboard/:metric" element={<Dashboard />} />
          <Route path="/dashboard/:category/:id" element={<DataTable />} />

          {/* Daily Data Table */}
          <Route path="/daily-data-table" element={<DailyDataTable />} />
          <Route path="/failed-logins/:date" element={<FailedLoginTable />} />

          {/* Analytics: ensure /analytics → /analytics/daily-data */}
          <Route path="/analytics" element={<Navigate to="/analytics/daily-data" replace />} />
          <Route path="/analytics/:metric" element={<Analytics />} />

          {/* Optional: keep analyticsRoutes if they add extra nested paths */}
          {analyticsRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

          {/* Other pages */}
          <Route path="/customer" element={<CustomerPage />} />
          <Route path="/customer/:popup" element={<CustomerPage />} />
          <Route path="/add-user" element={<AddUserPage />} />
          <Route path="/activity" element={<UserActivityPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/send-email" element={<SendEmailPage />} />

        </Route>

        {/* Fallback for unmatched paths (optional) */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}